import React from 'react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export function ITConsumablesTotalsRow(_ref) {
  let {
    claim,
    isShowInvolvement
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("td", {
    className: "col-form-label",
    md: 2
  }, "Totals"), /*#__PURE__*/React.createElement("td", {
    className: "p-1",
    md: 1
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "software_consumables_net_amount",
    object: claim,
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("td", {
    className: "p-1"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "software_consumables_qualifying_rnd_expenditure",
    object: claim,
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)));
}